import { fetchClientListAction } from "@/lib/actions/clients";

export interface ClientListEntry {
  id: string;
  name: string;
  status: string;
}

let inFlight: Promise<ClientListEntry[]> | null = null;

/**
 * One accessible-client fetch per page lifetime, shared by every surface that
 * needs the list (the company switcher today, global search next). The switcher
 * panel unmounts when it closes, so without this each open would refetch.
 *
 * A rejected fetch is dropped rather than cached, otherwise one failed request
 * would leave the switcher permanently empty for the rest of the session.
 */
export function loadClientList(): Promise<ClientListEntry[]> {
  inFlight ??= fetchClientListAction().catch((err: unknown) => {
    inFlight = null;
    throw err;
  });
  return inFlight;
}
